/**
 * @param el
 * @returns {Boolean}
 */
export default function isScrolledIntoView(el) {
    const elemTop = el.getBoundingClientRect().top;
    const elemBottom = el.getBoundingClientRect().bottom;
    return elemTop >= 0 && elemBottom <= window.innerHeight;
}



// WEBPACK FOOTER //
// ./src/components/helpers/isScrolledIntoView.js